module.exports = __webpack_public_path__ + "64a20539ada6caf8f9820dddd4ff94ad.png";